// src/hooks/useSystemStatus.js

import { useState, useEffect } from 'react';
import { checkServiceStatus, getAllServices } from '../ctapi/statusService';

export const useSystemStatus = () => {
    const services = getAllServices();
    const [statuses, setStatuses] = useState(
        services.map(s => ({ ...s, status: 'Checking...' }))
    );
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchAllStatuses = async () => {
            const statusPromises = services.map(service => 
                checkServiceStatus(service).then(status => ({ ...service, status }))
            );
            const results = await Promise.all(statusPromises);
            setStatuses(results);
            setIsLoading(false);
        };

        fetchAllStatuses();
    }, []); 

    return { statuses, isLoading };
};
